<app-dialog-header [title]="'MODULE.ARCHIVE_PROGRAM.TITLE' | translate" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <p class="mt-0 mb-16">{{ 'MODULE.ARCHIVE_PROGRAM.INTRO' | translate }}</p>
    <form [formGroup]="form">
        <mat-radio-group class="archive-option-group" formControlName="archive_option" fxLayout="column">
            <mat-radio-button class="archive-option mb-8" [value]="archiveOptionOnly">
                <div class="archive-option-label">{{ 'MODULE.ARCHIVE_PROGRAM.OPTION_ONLY_LABEL' | translate }}</div>
                <div class="archive-option-hint text-lightgreytextcolor">{{ 'MODULE.ARCHIVE_PROGRAM.OPTION_ONLY_HINT' | translate }}</div>
            </mat-radio-button>
            <mat-radio-button class="archive-option" [value]="archiveOptionAll">
                <div class="archive-option-label">{{ 'MODULE.ARCHIVE_PROGRAM.OPTION_ALL_LABEL' | translate }}</div>
                <div class="archive-option-hint text-lightgreytextcolor">{{ 'MODULE.ARCHIVE_PROGRAM.OPTION_ALL_HINT' | translate }}</div>
            </mat-radio-button>
        </mat-radio-group>
    </form>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [color]="'warn'" [label]="'GENERAL.BUTTON.ARCHIVE'" (onClick)="confirm()"></app-flat-button>
</div>
